import { Button, Select, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useLoaderData, useNavigate, useOutletContext } from 'react-router-dom';
import Axios from '../../utils/axios';
import Pagination from '../../../globalComponents/Pagination';
import Search from '../../../globalComponents/Search';



const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Internal Reference',
    dataIndex: 'internal_reference',
    key: 'internal_reference',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Sales Price',
    dataIndex: 'sales_price',
    key: 'sales_price',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Cost Price',
    dataIndex: 'cost_price',
    key: 'cost_price',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/inventory/products/'+record.number}>
        EDIT
      </Link>
    )
  }
]



const Products = () => {
  const loader = useLoaderData();
  const navigate = useNavigate();
  const { CustomBreadcrumb } = useOutletContext();
  const [value, setValue] = useState('');
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState('');
  const [searchProduct, setSearchProducts]= useState({products: loader.products ? loader.products : [], totalRows: loader.totalRows});
  const [paginations, setPaginations] = useState({pageSize: 100, page: 1});


  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/inventory/products/'+record.seo)
    };
  }

  const onChangeSearchFilter = (e) => {
    setValue(e);
    setOptions([]);
  };

  // useEffect(() => {
  //   Axios(`products/searched?seo=${value}`)
  //   .then(res => setSearchProducts(res.data))
  //   .catch(err => console.log(err))
  // },[value]);


  const debounce = (onChange) => {
    let timeout;
    return (value) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        onChange(value);
      }, 1000);
    };
  };

  const handleSearch = async (value) => {
    try {
        const response = await Axios(`products/search?query=${value}`);
        const responseData = await response.data;
        let data_ = responseData.map(item => ({value: item.seo, label: item.name}));
        setOptions(data_);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleChange = (e, option) => {
    let value_ = e.map(item => item.toLowerCase());
    setSearch(value_)
  }

  async function fetchUserList(search, pagination_) {

    return Axios(`products/searched?seo=${search}&&pagination=${JSON.stringify(pagination_)}`)
      .then((response) => response.data)
      .then((res) => {
        setSearchProducts(res);      
      });
  }

  useEffect(() => {
    // const totalPages = Math.ceil(paginations.total / paginations.pageSize);
    // if (paginations.page < 1) setPaginations({...paginations, page: 1});
    // if (paginations.page > totalPages) setPaginations({...paginations, page: totalPages});
    const offset = (paginations.page - 1) * paginations.pageSize;
    let pagination_ = {offset, pageSize: paginations.pageSize};
    // let filters = {search: {by: searchBy, values: search, filters: selectedFilters}};
    fetchUserList(search, pagination_);
  },[search, paginations])

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'><CustomBreadcrumb/></h3>
        <div className='w-1/2 bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Search search={search.length > 0 ? search : null} handleChange={handleChange}/>
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/inventory/products/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
          <Pagination paginations={paginations} total={searchProduct.totalRows} setPaginations={setPaginations}/>
          </div>
        </div>
      </div>
      <Table
        sticky
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={searchProduct.products.length > 0 ? searchProduct.products : loader.products}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'name'}
      />
    
    </div>
  )
}

export default Products;